import numeral from "numeral";
import PropTypes from "prop-types";
import "./dataRow.css";

const TotalRow = (props) => {
  const formatSize = (bytes) => {
    let formattedSize;
    if (props.selectedSizeFormat === "GB") {
      formattedSize =
        numeral((bytes / 1000000000).toFixed(2)).format("0,0.00") + " GB";
    } else if (props.selectedSizeFormat === "TB") {
      formattedSize =
        numeral((bytes / 1000000000000).toFixed(2)).format("0,0.00") + " TB";
    } else if (props.selectedSizeFormat === "MB") {
      formattedSize =
        numeral((bytes / 1000000).toFixed(2)).format("0,0.00") + " MB";
    }
    return formattedSize;
  };

  const totalCols = props.dataKeys.map((dataKey, i) => {
    let val;

    switch (dataKey) {
      case "Size":
        val = formatSize(props.totalSize);
        break;

      case "Hits":
        val = numeral(props.totalHits).format("0,0");
        break;

      case "Visitors":
        val = numeral(props.totalVisitors).format("0,0");
        break;

      case "Views":
        val = numeral(props.totalViews).format("0,0");
        break;

      case "Average Daily Size":
        val = formatSize(props.avgDailySize);
        break;

      case "Average Daily Hits":
        val = numeral(props.avgDailyHits).format("0,0");
        break;

      case "Description":
        val = "Total/Average";
        break;

      default:
        val = "";
    }
    return (
      <td
        key={i}
        className={
          dataKey.match(/Size/g) ||
          dataKey.match(/Hits/g) ||
          dataKey.match(/Visitors/g) ||
          dataKey.match(/Views/g)
            ? "bold right-align"
            : "bold center-align"
        }
      >
        {val}
      </td>
    );
  }, this);

  return <tr>{totalCols}</tr>;
};

TotalRow.propTypes = {
  selectedSizeFormat: PropTypes.string,
  dataKeys: PropTypes.array,
  totalSize: PropTypes.number,
  totalHits: PropTypes.number,
  totalVisitors: PropTypes.number,
  totalViews: PropTypes.number,
  avgDailySize: PropTypes.number,
  avgDailyHits: PropTypes.number,
};

export default TotalRow;
